var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 0.337733C1.27614 0.337587 1.38448 0.359103 1.48551 0.401041C1.58655 0.442979 1.67827 0.504509 1.7554 0.58208L6.01648 4.84259C6.1454 4.97155 6.29846 5.07385 6.46693 5.14364C6.63539 5.21343 6.81596 5.24936 6.9983 5.24936C7.18065 5.24936 7.36122 5.21343 7.52968 5.14364C7.69815 5.07385 7.85121 4.97155 7.98013 4.84259L12.2345 0.587633C12.3114 0.508073 12.4033 0.444613 12.5049 0.400957C12.6066 0.3573 12.7159 0.334321 12.8265 0.33336C12.9371 0.332399 13.0468 0.353475 13.1491 0.395359C13.2515 0.437243 13.3445 0.499095 13.4227 0.577308C13.5009 0.655521 13.5628 0.748527 13.6047 0.850899C13.6466 0.953272 13.6676 1.06296 13.6667 1.17357C13.6657 1.28417 13.6427 1.39348 13.5991 1.49511C13.5554 1.59674 13.492 1.68865 13.4124 1.76549L9.158 6.02046C8.58484 6.59255 7.80812 6.91385 6.9983 6.91385C6.18849 6.91385 5.41177 6.59255 4.83861 6.02046L0.577543 1.75994C0.46097 1.64344 0.381574 1.49498 0.349401 1.33335C0.317228 1.17171 0.333725 1.00416 0.396804 0.851906C0.459883 0.699649 0.566709 0.569525 0.703764 0.477998C0.84082 0.386472 1.00195 0.337658 1.16675 0.337733Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExpand);
export default __webpack_public_path__ + "static/media/arrowExpand.81d6453f5c557ecce7b63aa4047ef028.svg";
export { ForwardRef as ReactComponent };